import useBotControlStore from "../storeModules/useBotControlStore";
import findStep from "../screens/bot/stepModules/findStep";
import { persistStepToBack } from "./resumeStorage";

const noConnectionHandler = () => {
  return new Promise((resolve, reject) => {
    const useBotControlState = useBotControlStore.getState();
    const currentStep = useBotControlStore.getState().currentStep;

    if (!navigator.onLine) {
      persistStepToBack(currentStep);
      useBotControlStore.setState({
        ...useBotControlState,
        stepToBack: currentStep,
        currentStep: findStep("erro_conexao_inicio").index,
      });
      reject(new Error("Connection issue"));
    } else {
      resolve("Connected");
    }
  });
};

export default noConnectionHandler;
